import React, { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import DropSection from "@/components/landing/DropSection";
import HowItWorks from "@/components/landing/HowItWorks";
import MembersAccess from "@/components/landing/MembersAccess";
import Archive from "@/components/landing/Archive";
import Footer from "@/components/landing/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminWaitlist from "@/pages/AdminWaitlist";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Landing = () => {
  const membersRef = useRef(null);
  const dropRef = useRef(null);
  const howRef = useRef(null);
  const archiveRef = useRef(null);
  const [count, setCount] = useState(null);

  const scrollToMembers = () => {
    membersRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/waitlist/count`);
        setCount(r.data.count);
      } catch (_) {
        setCount(null);
      }
    })();
  }, []);

  const refreshCount = async () => {
    try {
      const r = await axios.get(`${API}/waitlist/count`);
      setCount(r.data.count);
    } catch (_) {}
  };

  return (
    <div className="App grain min-h-screen">
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "hsl(var(--scrm-elevated))",
            color: "hsl(var(--scrm-cream))",
            border: "1px solid hsl(var(--scrm-cream) / 0.15)",
            borderRadius: "2px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Nav onJoin={scrollToMembers} />

      <div id="top">
        <Hero onJoin={scrollToMembers} waitlistCount={count} />
      </div>
      <div id="drop" ref={dropRef}>
        <DropSection />
      </div>
      <div id="how" ref={howRef}>
        <HowItWorks />
      </div>
      <div ref={membersRef}>
        <MembersAccess onSuccess={refreshCount} />
      </div>
      <div id="archive" ref={archiveRef}>
        <Archive />
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/waitlist" element={<AdminWaitlist />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
